import { render, staticRenderFns } from "./VimeoUploadDialog.vue?vue&type=template&id=27735b5c&"
import script from "./VimeoUploadDialog.vue?vue&type=script&lang=js&"
export * from "./VimeoUploadDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports